"use client";

import React from "react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";
import { ArrowRight } from "lucide-react";
function NewsGrid() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6">
        {[1, 2, 3].map(i => <Card key={i} data-index={i} className="flex flex-row p-3 gap-4 rounded-lg shadow-sm border-border/40">
            <Skeleton className="w-28 h-24 sm:w-32 sm:h-28 rounded-md shrink-0" />
            <div className="flex flex-col flex-1 justify-between py-1">
              <div>
                <Skeleton className="h-4 w-16 mb-2 rounded-sm" />
                <Skeleton className="h-4 w-full mb-1.5" />
                <Skeleton className="h-4 w-4/5" />
              </div>
              <Skeleton className="h-3 w-24 mt-2" />
            </div>
          </Card>)}
      </div>;
  }
  if (error) {
    return <div className="text-sm text-destructive p-4 bg-destructive/10 rounded-md">
        Se produjo un error al cargar las noticias.
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="text-sm text-muted-foreground p-4 border border-dashed rounded-md text-center">
        No hay artículos relevantes en este momento.
      </div>;
  }
  return <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6">
      {posts.map((post, i) => {
      const category = post.categories?.[0]?.name || "Noticia";
      const date = post.date ? new Date(post.date).toLocaleDateString("es-ES", {
        day: "numeric",
        month: "long",
        year: "numeric"
      }) : "";
      const time = post.date ? new Date(post.date).toLocaleTimeString("es-ES", {
        hour: "2-digit",
        minute: "2-digit"
      }) : "";
      return <Card key={post.id} data-index={i} className="flex flex-row overflow-hidden rounded-lg shadow-sm hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300 border-border/40 bg-card p-0 group">
            <Link to={post.link || "#"} className="flex flex-row w-full p-3 gap-3 sm:gap-4">
              {}
              <div className="w-28 h-24 sm:w-32 sm:h-28 shrink-0 rounded-md overflow-hidden bg-muted relative">
                {post.featuredImage ? <img src={post.featuredImage} alt={post.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" loading="lazy" /> : <div className="w-full h-full flex items-center justify-center text-muted-foreground bg-accent/30">
                    <span className="text-[10px] uppercase tracking-widest font-sans">Sin Imagen</span>
                  </div>}
              </div>

              {}
              <div className="flex flex-col flex-1 justify-between min-w-0 py-0.5">
                <div>
                  <div className="mb-1.5">
                    <Badge className="bg-primary hover:bg-primary/90 text-primary-foreground text-[10px] px-2 py-0 h-4 rounded-sm font-sans font-bold uppercase tracking-tighter border-none">
                      {category}
                    </Badge>
                  </div>
                  <h3 className="text-sm sm:text-base font-bold font-default text-foreground leading-tight line-clamp-2 mb-1.5 group-hover:text-primary transition-colors" dangerouslySetInnerHTML={{
                __html: post.title
              }} />
                  {post.excerpt && <div className="text-xs text-muted-foreground line-clamp-2 hidden sm:block leading-relaxed font-sans" dangerouslySetInnerHTML={{
                __html: post.excerpt
              }} />}
                </div>
                <div className="text-[11px] text-muted-foreground mt-2 flex items-center gap-1.5 font-sans font-medium">
                  <span>{date}</span>
                  {time && <>
                      <span className="w-1 h-1 rounded-lg bg-muted-foreground/40"></span>
                      <span>{time}</span>
                    </>}
                </div>
              </div>
            </Link>
          </Card>;
    })}
    </div>;
}
export default function NewsSection() {
  const wp_query_params = {
    post_type: "post",
    per_page: 6,
    offset: 7,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="253760" id="relevantarticles" className="py-8 md:py-12 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        {}
        <div className="flex flex-row justify-between items-center mb-6 border-b border-border/50 pb-3">
          <h2 className="text-lg md:text-xl font-bold font-default uppercase text-foreground tracking-tight">
            Relevantes
          </h2>
          <Link to="#" className="text-sm font-bold font-sans text-primary hover:text-primary/80 hover:underline flex items-center gap-1 transition-colors">
            Todas las Noticias <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        {}
        <PostsProvider wp_query={{
        post_type: "post",
        per_page: 6,
        offset: 7,
        order: "desc",
        orderby: "date"
      }}>
          <NewsGrid />
        </PostsProvider>
      </div>
    </section>;
}